import moment from 'moment';

export const Urls = {
    appointment: {
        getData: '/api/Appointment',
        save: '/api/Appointment'
    },
    contact: {
        getData: '/api/Contact',
        save: '/api/Contact'
    },
    coupons: {
        getData: 'api/Coupons',
        signUp: '/Special-Offers/SignUp'
    },
    dealers: {
        get:'/api/DealerLocator'
    },
    infoPanel: {
        getData: '/api/InfoPanel',
        directions: '/api/Direction',
        sendToCell: '/api/Notification',
        carrier: '/api/Carrier'
    },
    callForm: {
        sendForm: '/api/SendCallForm'
    }
};

/**
 * for now it's shared
   later good idea
   to separate api by entities
 */
export default class Api {
    static getAppointmentData() {
        return fetch(Urls.appointment.getData)
            .then((res) => {
                return res.json();
            });
    }

    static submitAppointment(request) {
        try {
            var _navigator = {};
            for (var i in navigator) _navigator[i] = navigator[i];

            delete _navigator.plugins;
            delete _navigator.mimeTypes;

            request.userData = JSON.stringify({ 
                currentTime: new Date().toString(), 
                timezoneOffset: -(new Date().getTimezoneOffset()/60),
                userAgent: navigator.userAgent, 
                navigator: _navigator
            });
        } catch (error) {
            
        }
        
        return fetch(Urls.appointment.save,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(request)
            });
    }

    static getContactData() {
        return fetch(Urls.contact.getData)
            .then((res) => {
                return res.json();
            });
    }

    static submitContact(request) {
        return fetch(Urls.contact.save,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(request)
            });
    }

    static getDealers() {
        return fetch(Urls.dealers.get).then((res) => res.json());
    }

    
    static getCarrierInfo() {
        return fetch(Urls.infoPanel.carrier)
            .then((res) => {
                return res.json();
            });
    }

    static sendToCell(request) {
        return fetch(Urls.infoPanel.sendToCell,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(request)
            });
    }

    static sendCallForm(request) {
        return fetch(Urls.callForm.sendForm,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(request)
            });
    }

    static sendCouponSignUpForm(request) {
        return fetch(Urls.coupons.signUp,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(request)
            });
    }
}


// WEBPACK FOOTER //
// ./Src/Shared/Helpers/Api.js